/* Pages vélos (V39, test) : bloc du haut réorganisé, vues du vélo (glisser / flèches sous la photo / points),
   photo en grand au clic, caractéristiques. Chaque photo est recadrée automatiquement sur le vélo
   (marges transparentes ignorées) : le vélo a toujours la même taille. La photo s'affiche tout de suite,
   puis s'ajuste en douceur dès que le recadrage est calculé (mémorisé ensuite dans le navigateur).
   Contenus par page : assets/compact-refonte-data.js (clé = modèle de page, window.BRM_PAGE). */
(function () {
  var D = (window.BRM_PAGES || {})[window.BRM_PAGE] || {}, VIEWS = D.VIEWS || {}, SPECS = D.SPECS || [], DEPOSIT = D.DEPOSIT || '', NAME = D.NAME || 'Brumaire';
  var CDN = 'https://cdn.shopify.com/s/files/1/0624/3788/4070/files/';
  var GIFT = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v9H5v-9M7.5 8a2.5 2.5 0 1 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 1 1 0 5"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/></svg>';
  var ZOOM = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>';
  var CROSS = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var LEFT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var RIGHT = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function sized(url, w) { try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; } }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html) e.innerHTML = html; return e; }
  function btn(cls, html, label) { var b = el('button', cls, html); b.type = 'button'; b.setAttribute('aria-label', label); return b; }

  var known = {}, pending = {};
  function key(url) { return String(url).replace(/^https?:/, '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); }
  function store() { try { localStorage.setItem('brm-bbox', JSON.stringify(known)); } catch (e) {} }
  try { known = JSON.parse(localStorage.getItem('brm-bbox') || '{}') || {}; } catch (e) { known = {}; }
  function bbox(url) {
    var k = key(url);
    if (known[k]) return Promise.resolve(known[k]);
    if (pending[k]) return pending[k];
    pending[k] = new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        var ar = im.naturalHeight / im.naturalWidth, b;
        try {
          var w = 240, h = Math.max(1, Math.round(240 * ar)), c = document.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d'); x.drawImage(im, 0, 0, w, h);
          var d = x.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) for (var i = 0; i < w; i++) if (d[(y * w + i) * 4 + 3] > 24) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
          if (x1 < x0) throw 0;
          b = { ar: ar, x0: x0 / w, y0: y0 / h, bw: (x1 - x0 + 1) / w, bh: (y1 - y0 + 1) / h };
        } catch (e) { b = { ar: ar, x0: 0, y0: 0, bw: 1, bh: 1 }; }
        known[k] = b; store(); res(b);
      };
      im.onerror = function () { res(null); };
      im.src = sized(url, 240);
    });
    return pending[k];
  }
  function fit(frame, img, b, mx, my) {
    var W = frame.clientWidth, H = frame.clientHeight;
    if (!b || !W || !H) return;
    var dw = Math.min(W * mx / b.bw, H * my / (b.bh * b.ar)), dh = dw * b.ar;
    img.style.width = dw + 'px'; img.style.height = dh + 'px';
    img.style.left = (W / 2 - (b.x0 + b.bw / 2) * dw) + 'px';
    img.style.top = (H / 2 - (b.y0 + b.bh / 2) * dh) + 'px';
  }
  function place(frame, img, m, mx, my, done) {
    if (!m) return;
    var b = known[key(m.src)];
    if (b) { fit(frame, img, b, mx, my); done(); return; }
    if (img.naturalWidth) fit(frame, img, { ar: img.naturalHeight / img.naturalWidth, x0: 0, y0: 0, bw: 1, bh: 1 }, mx, my);
    done();
    bbox(m.src).then(function (bb) { if (bb && img.dataset.brmKey === key(m.src)) { img.classList.add('brm-glide'); fit(frame, img, bb, mx, my); } });
  }

  function init() {
    var pad = document.querySelector('.ProductShowcase__Padding');
    var img = document.querySelector('.ProductShowcase__FeaturedImage');
    if (!pad || !img || pad.classList.contains('brm-rf')) return;
    var q = function (s) { return pad.querySelector(s); };
    var cont = q('.ProductShowcaseContainer'), colB = cont && cont.children[1];
    var sub = q('.subheading'), h1 = q('h1'), price = q('.ProductShowcase__Price'), notes = q('.ProductShowcase__Notes'),
        colors = q('product-showcase-colors'), btns = colB && colB.querySelector('.buttons'), desc = colB && colB.querySelector('p');

    var grid = el('div', 'container brm-rf-grid'), media = el('div', 'brm-rf-media'), info = el('div', 'brm-rf-info');
    var stage = el('div', 'brm-rf-stage'), ctrl = el('div', 'brm-ctrl'), dots = el('div', 'brm-dots');
    var prev = btn('brm-arrow', LEFT, 'Vue précédente'), next = btn('brm-arrow', RIGHT, 'Vue suivante'), zoom = btn('brm-zoom', ZOOM, 'Afficher la photo en grand');
    dots.setAttribute('aria-label', 'Vues du vélo');
    var oldHost = img.parentElement;
    img.setAttribute('sizes', '(min-width: 768px) 55vw, 100vw');
    stage.appendChild(img); stage.appendChild(zoom);
    ctrl.appendChild(prev); ctrl.appendChild(dots); ctrl.appendChild(next);
    media.appendChild(stage); media.appendChild(ctrl);

    var colorBox = el('div', 'brm-rf-color'), label = el('p', 'brm-rf-label', 'Couleur : <strong></strong>');
    colorBox.appendChild(label); if (colors) colorBox.appendChild(colors);
    if (notes) {
      var offer = notes.querySelector('.ProductShowcase__Offer');
      if (offer && !offer.querySelector('svg')) {
        var t = offer.textContent.trim();
        offer.innerHTML = (/offert/i.test(t) ? GIFT : CHECK) + '<span>' + t.replace(/</g, '&lt;') + '</span>';
      }
    }
    var deposit = el('p', 'brm-rf-deposit'); deposit.textContent = DEPOSIT;
    var specs = el('ul', 'brm-rf-specs'); specs.setAttribute('aria-label', 'Caractéristiques principales');
    SPECS.forEach(function (s) { var li = el('li'), v = el('strong'), l = el('span'); v.textContent = s[0]; l.textContent = s[1]; li.appendChild(v); li.appendChild(l); specs.appendChild(li); });
    [sub, h1, price, notes, colorBox, btns, DEPOSIT ? deposit : null, SPECS.length ? specs : null].forEach(function (e) { if (e) info.appendChild(e); });
    if (desc) { desc.classList.add('brm-rf-desc'); info.appendChild(desc); }
    grid.appendChild(media); grid.appendChild(info); pad.appendChild(grid);
    if (oldHost && oldHost !== pad && !oldHost.querySelector('img')) oldHost.style.display = 'none';
    pad.classList.add('brm-rf');

    var sticky = document.querySelector('.ProductShowcase__Sticky');
    if (sticky && btns && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('brm-rf-sticky-off', en[0].isIntersecting); }).observe(btns);
    }

    var lb = el('div', 'brm-lb'), lbFrame = el('div', 'brm-lb-frame'), lbImg = el('img'), lbBar = el('div', 'brm-lb-bar');
    var lbClose = btn('brm-lb-close', CROSS, 'Fermer'), lbPrev = btn('brm-arrow', LEFT, 'Vue précédente'), lbNext = btn('brm-arrow', RIGHT, 'Vue suivante'), lbCount = el('p', 'brm-lb-count');
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Photos du ' + NAME); lb.hidden = true;
    lbImg.alt = ''; lbFrame.appendChild(lbImg);
    lbBar.appendChild(lbPrev); lbBar.appendChild(lbCount); lbBar.appendChild(lbNext);
    lb.appendChild(lbClose); lb.appendChild(lbFrame); lb.appendChild(lbBar);
    document.body.appendChild(lb);

    var list = [], cur = 0, color = '';
    function paint() {
      [].forEach.call(dots.children, function (d, i) { if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      var multi = list.length > 1;
      ctrl.hidden = lbBar.hidden = !multi;
      lbCount.textContent = (cur + 1) + ' / ' + list.length;
    }
    function layoutMain() { var m = list[cur]; if (!m) return; img.dataset.brmKey = key(m.src); place(stage, img, m, 0.9, 0.86, function () { img.classList.remove('brm-fading'); }); }
    function layoutLb() { var m = list[cur]; if (!m || lb.hidden) return; lbImg.dataset.brmKey = key(m.src); place(lbFrame, lbImg, m, 0.94, 0.9, function () { lbImg.classList.add('on'); }); }
    function showMain(m) {
      img.classList.remove('brm-glide'); img.classList.add('brm-fading');
      if (typeof productShowcaseSetImage === 'function') productShowcaseSetImage(img, m.src); else img.src = sized(m.src, 1400);
      img.alt = NAME + ' ' + color + ', ' + m.alt;
      if (img.complete) layoutMain();
    }
    function showLb() {
      if (lb.hidden) return; var m = list[cur]; lbImg.classList.remove('on', 'brm-glide');
      lbImg.onload = layoutLb; lbImg.src = sized(m.src, 2000); lbImg.alt = NAME + ' ' + color + ', ' + m.alt;
      if (lbImg.complete) layoutLb();
    }
    function go(i) { if (list.length < 2) return; cur = (i + list.length) % list.length; paint(); showMain(list[cur]); showLb(); }
    img.addEventListener('load', layoutMain);

    function build(sw) {
      if (!sw) return;
      color = sw.getAttribute('data-color');
      label.querySelector('strong').textContent = color;
      list = [{ alt: 'vue de profil', src: sw.getAttribute('data-image') || img.getAttribute('src') || img.currentSrc }];
      (VIEWS[color] || []).forEach(function (v) { list.push({ alt: v[1], src: CDN + v[0] }); });
      cur = 0; dots.innerHTML = ''; img.classList.remove('brm-glide');
      list.forEach(function (m, i) {
        var b = btn('', '', 'Afficher la ' + m.alt + ' (' + (i + 1) + '/' + list.length + ')');
        b.addEventListener('click', function () { go(i); });
        dots.appendChild(b); bbox(m.src);
      });
      paint();
      if (img.complete) layoutMain();
    }

    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    lbPrev.addEventListener('click', function () { go(cur - 1); });
    lbNext.addEventListener('click', function () { go(cur + 1); });

    var lastFocus = null;
    function openLb() { lastFocus = document.activeElement; lb.hidden = false; document.documentElement.classList.add('brm-lb-open'); showLb(); setTimeout(function () { lbClose.focus({ preventScroll: true }); }, 30); }
    function closeLb() { lb.hidden = true; document.documentElement.classList.remove('brm-lb-open'); if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); }
    zoom.addEventListener('click', function (e) { e.stopPropagation(); openLb(); });
    lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbFrame) closeLb(); });

    var swiped = 0;
    function swipeOn(zone, pic) {
      var x0 = null, y0 = 0, horiz = false;
      zone.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; horiz = false; pic.style.transition = 'none'; }, { passive: true });
      zone.addEventListener('touchmove', function (e) {
        if (x0 === null || list.length < 2) return;
        var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
        if (!horiz && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) horiz = true;
        if (horiz) pic.style.transform = 'translateX(' + Math.round(dx * 0.6) + 'px)';
      }, { passive: true });
      zone.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        pic.style.transition = ''; pic.style.transform = '';
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = Date.now(); go(cur + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    }
    swipeOn(stage, img); swipeOn(lbFrame, lbImg);
    stage.addEventListener('click', function (e) { if (Date.now() - swiped < 500 || e.target.closest('button')) return; openLb(); });

    if ('IntersectionObserver' in window && window.matchMedia('(max-width: 767.98px)').matches) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || list.length < 2) return; io.disconnect();
        setTimeout(function () { stage.classList.add('brm-nudge'); setTimeout(function () { stage.classList.remove('brm-nudge'); }, 1300); }, 600);
      }, { threshold: 0.7 });
      io.observe(stage);
    }

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb(); else if (e.key === 'ArrowLeft') go(cur - 1); else if (e.key === 'ArrowRight') go(cur + 1);
      else if (e.key === 'Tab') { var f = [lbClose, lbPrev, lbNext].filter(function (b) { return b.offsetParent; }); var i = f.indexOf(document.activeElement); e.preventDefault(); f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus(); }
    });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { img.classList.remove('brm-glide'); layoutMain(); layoutLb(); }, 80); });

    build(pad.querySelector('.ProductShowcase__Color.active') || pad.querySelector('.ProductShowcase__Color'));
    document.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.ProductShowcase__Color');
      if (sw) setTimeout(function () { build(sw); }, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();